"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarPanel = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../util/hooks");
const SidebarPanel = function (props) {
    const { c } = props;
    const { selectPanel, setPanel, panelRenderer } = c;
    const [menuRef, open, setOpen] = (0, hooks_1.useAutoClose18)({
        extendSearch: 'sidebar-panel',
        noScip: true,
        closeFc: () => {
            setPanel(null);
        },
    });
    (0, react_1.useEffect)(() => {
        if (selectPanel && !open) {
            setOpen(true);
        }
        else if (!selectPanel && open) {
            setOpen(false);
        }
    }, [selectPanel, open, setOpen]);
    if (selectPanel === null)
        return null;
    return (react_1.default.createElement("div", { ref: menuRef, className: "sidebar-panel glx-animation-fade-in-super-fast" }, panelRenderer(selectPanel)));
};
exports.SidebarPanel = SidebarPanel;
